import { OnDestroy, OnInit, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Auth } from '@freelancer/auth';
import { CONTEST_ENTRY_AWARD_STATUSES, CONTEST_ENTRY_IMAGE_FORMATS, CONTEST_ENTRY_VIDEO_FORMATS, Datastore, EntryAction, toNumber, } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { FileDisplaySize } from '@freelancer/ui/file-display';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { PictureDisplay } from '@freelancer/ui/picture';
import { RibbonColor, RibbonOrientation, RibbonPlacement, } from '@freelancer/ui/ribbon';
import { FontColor, FontSize, FontWeight, TextTransform, } from '@freelancer/ui/text';
import { AvatarSize } from '@freelancer/ui/user-avatar';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';
import { PreviewModalResponse } from './preview-modal.types';
var PreviewModalComponent = /** @class */ (function () {
    function PreviewModalComponent(auth, datastore, modalRef) {
        this.auth = auth;
        this.datastore = datastore;
        this.modalRef = modalRef;
        this.AvatarSize = AvatarSize;
        this.ButtonColor = ButtonColor;
        this.ButtonSize = ButtonSize;
        this.FileDisplaySize = FileDisplaySize;
        this.FontColor = FontColor;
        this.FontSize = FontSize;
        this.FontWeight = FontWeight;
        this.HeadingSize = HeadingSize;
        this.HeadingType = HeadingType;
        this.IconColor = IconColor;
        this.IconSize = IconSize;
        this.Margin = Margin;
        this.PictureDisplay = PictureDisplay;
        this.RibbonColor = RibbonColor;
        this.RibbonOrientation = RibbonOrientation;
        this.RibbonPlacement = RibbonPlacement;
        this.TextTransform = TextTransform;
        this.THUMBNAIL_LIMIT = 5;
        this.REJECT_ENTRY_CONTENTS = { status: "eliminated" /* ELIMINATED */ };
        this.RECONSIDER_ENTRY_CONTENTS = { status: "active" /* ACTIVE */ };
        this.DESCRIPTION_LIMIT = 200;
        this.ratingControl = new FormControl();
        this.thumbnails = [];
        this.currentFileIndex = 0;
        this.tabs = [
            {
                title: 'Comments',
                selected: true,
            },
        ];
        this.COMMENT_LIMIT_INCREMENT = 50;
        this.commentLimitSubject$ = new Rx.BehaviorSubject(this.COMMENT_LIMIT_INCREMENT);
        this.commentLimit$ = this.commentLimitSubject$.asObservable();
        /**
         * Placeholder variables.
         * TODO: Replace variables with dynamic data -- hooked from the backend.
         */
        this.country = 'au';
    }
    PreviewModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Datastore call needed to have the entry status change reflected on the modal upon user CTA
        this.entry$ = this.datastore
            .document('contestViewEntries', this.entry.id)
            .valueChanges();
        this.isHighlighted$ = this.entry$.pipe(map(function (entry) {
            return !!(_this.entry.upgrades &&
                _this.entry.upgrades.highlight &&
                !_this.hasContestAwardedEntry &&
                ![
                    "eliminated" /* ELIMINATED */,
                    "withdrawn" /* WITHDRAWN */,
                    "withdrawn_eliminated" /* WITHDRAWN_ELIMINATED */,
                ].includes(entry.status));
        }));
        this.isActive$ = this.entry$.pipe(map(function (entry) {
            return !_this.hasContestAwardedEntry &&
                entry.status === "active" /* ACTIVE */;
        }));
        this.isRejected$ = this.entry$.pipe(map(function (entry) {
            return [
                "eliminated" /* ELIMINATED */,
                "withdrawn_eliminated" /* WITHDRAWN_ELIMINATED */,
            ].includes(entry.status);
        }));
        this.ratingControl.setValue(this.entry.rating);
        this.ratingSubscription = this.ratingControl.valueChanges.subscribe(function (rating) { return _this.onRateEntry({ rating: rating }); });
        this.thumbnails = this.entry.files.map(function (file) { return ({
            src: file.thumbnail80Url || '',
            alt: ' ',
        }); });
        this.commentsCollection = this.datastore.collection('contestEntryMessages', function (query) {
            return query.where('entryId', '==', _this.entry.id).limit(_this.commentLimit$);
        });
        var userId$ = this.auth.getUserId().pipe(map(function (id) { return toNumber(id); }));
        this.user$ = this.datastore.document('users', userId$).valueChanges();
    };
    PreviewModalComponent.prototype.onAwardEntry = function () {
        // TODO: Open award modal directly in preview modal after T82677 is done
        this.modalRef.close(PreviewModalResponse.AWARD);
    };
    PreviewModalComponent.prototype.onSlideChange = function (index) {
        this.currentFileIndex = index;
    };
    PreviewModalComponent.prototype.onViewMoreComments = function () {
        this.commentLimitSubject$.next(this.commentLimitSubject$.getValue() + this.COMMENT_LIMIT_INCREMENT);
    };
    PreviewModalComponent.prototype.isSealed = function () {
        return this.entry.upgrades && this.entry.upgrades.sealed;
    };
    PreviewModalComponent.prototype.isAwarded = function () {
        return CONTEST_ENTRY_AWARD_STATUSES.includes(this.entry.status);
    };
    PreviewModalComponent.prototype.isBought = function () {
        return this.entry.status === "bought" /* BOUGHT */;
    };
    PreviewModalComponent.prototype.isBeingSold = function () {
        return (this.hasContestAwardedEntry &&
            this.entry.status === "active" /* ACTIVE */ &&
            (this.entry.sellPrice || this.contest.prize));
    };
    PreviewModalComponent.prototype.isImage = function (filename) {
        var fileType = filename.split('.').pop();
        fileType = fileType ? fileType.toLowerCase() : filename;
        return CONTEST_ENTRY_IMAGE_FORMATS.includes(fileType);
    };
    PreviewModalComponent.prototype.isVideo = function (filename) {
        var fileType = filename.split('.').pop();
        fileType = fileType ? fileType.toLowerCase() : filename;
        return CONTEST_ENTRY_VIDEO_FORMATS.includes(fileType);
    };
    PreviewModalComponent.prototype.isEntryOwner = function () {
        return this.userId === this.entry.ownerId;
    };
    PreviewModalComponent.prototype.showErrorsOnHeader = function () {
        var headerEntryActions = [
            EntryAction.RATE,
            EntryAction.REJECT,
            EntryAction.RECONSIDER,
        ];
        return headerEntryActions.includes(this.entryAction);
    };
    PreviewModalComponent.prototype.onRateEntry = function (changes) {
        this.entryAction = EntryAction.RATE;
        this.updateResponse$ = this.updateEntry(changes);
    };
    PreviewModalComponent.prototype.onRejectEntry = function (changes) {
        this.entryAction = EntryAction.REJECT;
        this.rejectResponse$ = this.updateEntry(changes);
        this.updateResponse$ = this.rejectResponse$;
    };
    PreviewModalComponent.prototype.onReconsiderEntry = function (changes) {
        this.entryAction = EntryAction.RECONSIDER;
        this.reconsiderResponse$ = this.updateEntry(changes);
        this.updateResponse$ = this.reconsiderResponse$;
    };
    PreviewModalComponent.prototype.onLikeEntry = function (changes) {
        this.entryAction = this.entry.isLiked
            ? EntryAction.DISLIKE
            : EntryAction.LIKE;
        this.updateResponse$ = this.updateEntry(changes);
    };
    PreviewModalComponent.prototype.updateEntry = function (changes) {
        return this.datastore
            .document('contestViewEntries', this.entry.id)
            .update(changes);
    };
    PreviewModalComponent.prototype.handleChatClick = function () {
        this.modalRef.close(PreviewModalResponse.START_CHAT);
    };
    PreviewModalComponent.prototype.ngOnDestroy = function () {
        this.ratingSubscription.unsubscribe();
    };
    return PreviewModalComponent;
}());
export { PreviewModalComponent };
